import { Actions, thunk } from 'easy-peasy';

import { IClientActions } from '~/store/client/types';
import { IReportsActions } from '~/store/reports/types';
import { ISystemAlertActions } from '~/store/systemAlert/types';
import { IResourceActions } from '~/store/resource/types';
import { IActTeamActions } from '~/store/actTeam/types';
import { ICoordinateActions } from '~/store/coordinate/types';
import { INetworkActions } from '~/store/network/types';
import { clearAllFilters } from '~/services/localStorage/filters';
import {
  deletePasswordExpiration,
  deleteSendbirdData,
  deleteTokens,
  deleteUserData,
} from '~/services/localStorage/auth';
import { removeDraftAllocation } from '~/services/localStorage/allocations';
import { IThunkLogout, IUserActions } from '../types';

const onLogout: IThunkLogout = thunk(
  async (
    {
      resetUser,
      setAuthorized,
      resetReportsStore,
      resetSystemAlertsStore,
      resetClientStore,
      resetResourceStore,
      resetActTeamStore,
      resetCoordinateStore,
      resetNetworkStore,
    }: Actions<
      IUserActions &
        Pick<IReportsActions, 'resetReportsStore'> &
        Pick<IResourceActions, 'resetResourceStore'> &
        Pick<ISystemAlertActions, 'resetSystemAlertsStore'> &
        Pick<IActTeamActions, 'resetActTeamStore'> &
        Pick<INetworkActions, 'resetNetworkStore'> &
        Pick<IClientActions, 'resetClientStore'> &
        Pick<ICoordinateActions, 'resetCoordinateStore'>
    >,
    _payload,
    { getStoreActions },
  ) => {
    const { resetCommunityEngagement } = getStoreActions().communityEngagement;

    resetUser();
    setAuthorized({ authorized: false });
    deleteTokens();
    deletePasswordExpiration();
    deleteUserData();
    deleteSendbirdData();
    resetReportsStore();
    resetResourceStore();
    resetSystemAlertsStore();
    resetCoordinateStore();
    resetClientStore();
    clearAllFilters();
    resetActTeamStore();
    resetNetworkStore();
    removeDraftAllocation();
    resetCommunityEngagement();
  },
);

export default onLogout;
